export default "__VITE_ASSET__8d738313__"